<script>
import Vue from "vue";
import backendCall from "@/lib/backendCall";
import store from "@/store";

export default {
  computed: {
    storeProfile: () => {
      return store.state.storeProfile ? store.state.storeProfile : null
    },
    storeInfo: () => {
      return store.state.storeInfo ? store.state.storeInfo : null
    }
  },
  methods: {
    async getStoreInfoAndProfile(storeAccount) {
      try {
        await this.getStoreInfo(storeAccount)
        if (this.storeInfo) {
          await this.getStoreProfile(storeAccount)
        }
      } catch (e) {
        console.error(e)
        Vue.notify({
          type: 'error',
          text: e.message
        })
      }
    },
    async getStoreInfo(storeAccount) {
      try {
        const storeInfoRes = await backendCall.store.getStoreInfo(storeAccount)
        console.log("store info res: ", storeInfoRes)
        if (storeInfoRes.status === 0) {
          throw Error(storeInfoRes.message)
        }
        if (!storeInfoRes.data) {
          store.state.storeInfo = null
          return
        }
        store.state.storeInfo = storeInfoRes.data
      } catch (e) {
        throw Error(e.message)
      }
    },
    async getStoreProfile(storeAccount) {
      try {
        const storeProfileRes = await backendCall.store.getStoreProfile(storeAccount)
        console.log(storeProfileRes)
        if (storeProfileRes.status === 0) {
          throw Error(storeProfileRes.message)
        }
        if (!storeProfileRes.data) {
          store.state.storeProfile = null
          return
        }
        store.state.storeProfile = storeProfileRes.data
      } catch (e) {
        throw Error(e.message)
      }
    },
  }
}
</script>